
import Draw from 'ol/interaction/Draw';
import VectorSource from 'ol/source/Vector';

function createInteractionSelectObjectPoint(options) {
    let source = new VectorSource({});

    let draw = new Draw({
        source: source,
        type: 'Point'
    });

    draw.set('mapToolId', 'SelectObjectPoint');
    draw.setActive(false);

    draw.on('drawend', (e) => {
        if (options.onMapToolExecute) {
            options.onMapToolExecute(
                draw.get('mapToolId'),
                {
                    geometry: e.feature.get('geometry')
                }
            );
        }
    });

    return draw;
}

export default createInteractionSelectObjectPoint;
